export default "__VITE_ASSET__kHi2$VlP__"